export var CASCADE_LEVELS = ['program'];
export var TAKEDOWN_STATUS;
(function (TAKEDOWN_STATUS) {
    TAKEDOWN_STATUS["Active"] = "Active";
    TAKEDOWN_STATUS["Expired"] = "Expired";
})(TAKEDOWN_STATUS || (TAKEDOWN_STATUS = {}));
